module.exports = __webpack_public_path__ + "media/components/footer/static/phone-d40e29ab7a72a0c0dca2056a33906a7c.png";